import React, { useCallback, useEffect, useState } from 'react'

import SelectButton, { Option } from 'src/components/molecules/SelectButton'
import { ENABLE_SYNC_ORG_CODES } from 'src/domain/org'
import {
  AdminAdminSalesReportManagerRoles,
  isOneOfRoles,
} from 'src/domain/role'
import { RoleEnum } from 'src/slices/services/api'

export type FinalizeReportButtonProps = {
  onClickStartFinalization?: () => void
  onClickSend?: () => void
  syncCount: number
  checkCount: number
  orgCode: string
  role?: RoleEnum
} & React.StyledProps

const FinalizeReportButton: React.StyledFC<FinalizeReportButtonProps> = ({
  className,
  onClickStartFinalization,
  onClickSend,
  syncCount,
  checkCount,
  orgCode,
  role,
}: FinalizeReportButtonProps) => {
  const [selectOptions, setSelectOptions] = useState<Option[]>([
    {
      icon: 'check',
      title: '確認開始',
      count: 0,
      onClick: onClickStartFinalization,
    },
  ])

  const isCheckOrSyncAvailable = useCallback(() => {
    return syncCount > 0 || checkCount > 0
  }, [syncCount, checkCount])

  useEffect(() => {
    const startCheck: Option = {
      icon: 'check',
      title: '確認開始',
      count: checkCount,
      onClick: onClickStartFinalization,
    }
    const startSend: Option = {
      icon: 'send',
      title: 'データ連携',
      count: syncCount,
      disabled: syncCount === 0,
      onClick: onClickSend,
    }

    if (
      isOneOfRoles(AdminAdminSalesReportManagerRoles, role) &&
      ENABLE_SYNC_ORG_CODES.includes(orgCode)
    ) {
      setSelectOptions([startCheck, startSend])
      return
    }
    setSelectOptions([startCheck])
  }, [
    syncCount,
    checkCount,
    orgCode,
    role,
    onClickStartFinalization,
    onClickSend,
  ])

  return (
    <SelectButton
      className={className}
      options={selectOptions}
      disabled={!isCheckOrSyncAvailable()}
    />
  )
}

export default FinalizeReportButton
